export default __webpack_public_path__ + "static/ehv-silky-black-063b961bed9338f037740daf5449e01c.webp";